import { ViewModel,View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import  { ColorManipulationView } from "./colorManipulation-view"

export class ColorManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت رنگ ها ‌';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.colors = ObservableArray.create<color>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new ColorManipulationView();
    }
    public getTypeId(): string {
        return "VM-C06B0A13-024C-4BF5-9DFD-9F780880152F"
    }
    public set colors(v: ObservableArray<color>) { this._colors = v; } public get colors(): ObservableArray<color> { return this._colors;} private _colors: ObservableArray<color>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllColor',{
                FilteringInformation:filteringInformation
            });
            this.colors.update(...result.Color.map(q=>{
                let r = new color(this);
                r.id = q.Id;
                r.name = q.Name;
                r.code = q.Code;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    async requestColorCreation(){
        let editor = new colorEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async colorUpdater(color:color){
        let editor = new colorEditor(this,new UpdateServerUpdater());
        color.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
}

export class color extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ColorManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    
    private _typedParent:ColorManipulationViewModel;

    clone(parent:ColorManipulationViewModel):color{
        let u = new color(parent);
        this.cloneTo(u);
        return u;
    }

    cloneTo(color:color){
        color.id = this.id;
        color.name = this.name;
        color.code = this.code;
    }

    async edit(){
        this._typedParent.colorUpdater(this);
    }    
}

interface IServerUpdater{
    execute(color:color):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'رنگ با موفقیت ثبت شد.';
    }
    async execute(color: color): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/CreateColor',{
            Name:color.name,
            Code:color.code
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}
class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'رنگ با موفقیت به روز رسانی شد.';

    }
    async execute(color: color): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/UpdateColor',{
            Id:color.id,
            Name:color.name,
            Code:color.code
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

export class colorEditor extends color implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:ColorManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push('نام رنگ مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.code)){
            result.push('کد رنگ مشخص نشده است.')
        }
        return result;
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت رنگ');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }
}

export class ColorSelectorViewModel extends SelectorBaseViewModel<colorForSelector>{
    protected async loadData(): Promise<colorForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllColor',{});
        return result.Color.map(q=>{
            let result = new colorForSelector(this);
            result.id = q.Id;
            result.title = q.Name;
            return result;
        });
    }

}

class colorForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);   
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}
